module.exports = __webpack_public_path__ + "img/vip.0745a361.svg";